<div class="dashboard-descriptive-select-field">
	<!-- Input Group with Icon and Floating Label (matching Bootstrap style) -->
	<div class="input-group">
		<span class="input-group-text">
			@if(saving()){<i class="fa-fw fa-regular fa-spin fa-spinner-third"></i>}
			@else if(error() !== ''){<i class="fa-fw fa-solid fa-circle-xmark color-darkred"></i>}
			@else if(customIcon()){<i [ngClass]="customIcon()"></i>}
			@else{<i class="fa-fw fa-regular fa-hand-pointer"></i>}
		</span>
		<div class="form-floating">
			<kendo-dropdownlist [value]='selectedItem()' [data]="setup().data()" [valueField]="'uniqueId'"
				[textField]="'title'" [virtual]="false" [filterable]="isFilterable()" [itemDisabled]="itemDisabled"
				[defaultItem]="placeholder() ? defaultItem : null" [disabled]='disabled()'
				(filterChange)="handleFilter($event)" (valueChange)='valueChangeEvent($event)' [ngClass]='cssClass()'
				style='width:100%;' [popupSettings]="{ appendTo: 'component', animate: false }"
				[id]="'descriptive-select-' + uniqueId()">

				<!-- No Data Template -->
				<ng-template kendoDropDownListNoDataTemplate>
					<i>{{missingDataMessage()}}</i>
				</ng-template>

				<!-- Value Template (Selected Item Display) -->
				<ng-template kendoDropDownListValueTemplate let-dataItem>
					@if(dataItem) {
					@if(valueTemplate) {
					<!-- User-provided custom value template -->
					<ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: dataItem }"></ng-container>
					} @else {
					<!-- Default value template with icon, title, and description -->
					<div class="descriptive-select-value">
						@if(dataItem.iconClass) {
						<i [class]="dataItem.iconClass" [style.color]="dataItem.iconColor || '#666'"></i>
						}
						<div class="descriptive-select-value-content">
							<div class="descriptive-select-value-title">
								@if(dataItem.groupName) {
								<span class="group-indicator">{{dataItem.groupName}} → </span>
								}
								{{dataItem.text}}
							</div>
							@if(dataItem.subText && showSubTextInValue()) {
							<div class="descriptive-select-value-description">{{dataItem.subText}}</div>
							}
						</div>
					</div>
					}
					}
				</ng-template>

				<!-- Item Template (Dropdown List Items) -->
				<ng-template kendoDropDownListItemTemplate let-dataItem>
					@if(itemTemplate) {
					<!-- User-provided custom item template -->
					<ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: dataItem }"></ng-container>
					} @else {
					<!-- Default item template with icon, title, and description -->
					<div class="descriptive-select-item">
						@if(dataItem.iconClass) {
						<i [class]="dataItem.iconClass" [style.color]="dataItem.iconColor || '#666'"></i>
						}
						<div class="descriptive-select-item-content">
							<div class="descriptive-select-item-title">{{dataItem.text}}</div>
							@if(dataItem.subText) {
							<div class="descriptive-select-item-description">{{dataItem.subText}}</div>
							}
						</div>
					</div>
					}
				</ng-template>

			</kendo-dropdownlist>
			<label class="color-gray" [for]="'descriptive-select-' + uniqueId()">
				{{label()}}
			</label>
		</div>
	</div>
</div>